import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "riwayatPangkat";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const riwayatPangkatList = "Kepegawaian/RiwayatPangkat/list/";
export const riwayatPangkatDetail = "Kepegawaian/RiwayatPangkat/detail/";
export const riwayatPangkatLogDetail = "Kepegawaian/RiwayatPangkat/logdetail/";
export const riwayatPangkatUploadSK = "Kepegawaian/RiwayatPangkat/uploadSK/";
export const masterRank = "Kepegawaian/RiwayatPangkat/get_rank/";
export const masterRankType = "Kepegawaian/RiwayatPangkat/get_ranktipe/";
export const createRiwayatPangkat = "Kepegawaian/RiwayatPangkat/create/";
export const updateRiwayatPangkat = "Kepegawaian/RiwayatPangkat/update/";
export const riwayatpangkatInactive = "Kepegawaian/RiwayatPangkat/inactive/";
export const approveRiwayatPangkat = "Kepegawaian/RiwayatPangkat/approve/";
export const getConfig = "Kepegawaian/RiwayatPangkat/getConfig/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
